<template>
    <ui-container class="space-y-8 py-8">

        <!-- Header. -->
        <ui-header v-if="canManage">
            <template #actions>
                <ui-button-new v-if="canManage" icon="fas fa-pencil" @click="edit()">Edit</ui-button-new>
                <ui-button-new v-if="canManage" icon="fas fa-trash" danger @click="openDeleteModal">Delete</ui-button-new>
            </template>
        </ui-header>

        <!-- Data grid. -->
        <ui-data-grid>
            <ui-data-grid-item v-if="canManage" label="Requires User Acknowledgement">{{ item.requires_acknowledgement | human_bool }}</ui-data-grid-item>
            <ui-data-grid-item v-if="canManage && item.renews_at" label="HSQE Review Due Date" :value="`${item.renews_at} (${item.renews_at_diff })`"></ui-data-grid-item>
            <ui-data-grid-item v-if="canManage && item.team_limited" label="Related To Teams" :value="item.teams.map(team => team.name).join(', ')"></ui-data-grid-item>
            <ui-data-grid-item v-if="item.document" wide>
              <div class="company-document-outer-container">
                  <header>
                      <img src="/img/logo-header-inverted.png" style="width:200px">
                      <div>
                          <div>Document Ref : {{ item.reference }}</div>
                          <div>Version : {{ item.version }}</div>
                          <div><strong>{{ item.title }}</strong></div>
                      </div>
                  </header>
                  <div class="company-document-container" v-html="item.document.body"></div>
                  <br>
                  <div class="flex flex-col md:flex-row flex-wrap -m-2">
                    <ui-button-new v-if="canManage && item.published_at" class="m-2" icon="fa fa-pencil" @click="item.unpublish()">Set To Draft</ui-button-new>
                    <ui-button-new v-if="canManage && ! item.published_at" class="m-2" icon="fa fa-check" @click="item.publish()" success>Publish</ui-button-new>
                    <ui-button-new v-if="! canManage" class="m-2" icon="fa fa-check" @click="item.acknowledge()" success>Acknowledge Document As Read &amp; Understood</ui-button-new>
                  </div>
              </div>
            </ui-data-grid-item>
            <ui-data-grid-item label="Created By" :value="item.created_by"></ui-data-grid-item>
            <ui-data-grid-item label="Created At" :value="item.created_at"></ui-data-grid-item>
            <ui-data-grid-item label="Published By" :value="item.published_by"></ui-data-grid-item>
            <ui-data-grid-item label="Published At" :value="item.published_at"></ui-data-grid-item>
        </ui-data-grid>

    </ui-container>
</template>

<script>
export default {
    props: {
        item: Object,
        edit: Function,
        removeItem: Function,
        canManage: Boolean,
    },
    methods: {
        openDeleteModal () {
            const title = 'Are you sure you want to delete "' + this.item.title + '"?'
            const description = 'Deleting this document is irreversible. Are you sure you want to delete it?'
            eventBus.$emit('delete-modal-open', title, description, async () => {
                await this.item.delete()
                this.removeItem(this.item)

            });
        },
    },
}
</script>

<style lang="scss" scoped>
.company-document-container {
    background-color: #FFF;
    border-radius: $standardBorderRadius;
    @include resetListStyling();

    textarea, .ck-editor {
        background-color: #FFF !important;
    }
}

.company-document-outer-container {
    @include clearfix();
    margin: 0px;
    padding: 2em;
    border-radius: 10px;
    border: 3px solid #cedbe1;
    header {
        margin-bottom:2em;
    }
    header img {
        float: left;
    }

    header > div {
        float: right;

        div {
            text-align: right;

            &:last-of-type {
                font-size: 24px;
            }
        }
    }
}
</style>
